const messages = {
  counter: { id: 'admin/promotions.form.utils.count' },
}

export default messages
